// Module registry that drives the client nav + routes.
//
// Seeded at build time (a snapshot of the backend modules.config.js) so the SPA
// has an instant first paint — then reconciled at runtime from
// GET /api/meta/modules so edits to modules.config.js show up WITHOUT a client
// rebuild. The runtime copy is the single source of truth; the seed is only the
// first-paint fallback. Consume via useModules().
import { useState, useEffect } from 'react';
import axios from 'axios';

export const seedModules = {
  core: {
    key: 'core',
    label: 'Administration',
    icon: 'shield',
    models: ['User', 'Role', 'Permission'],
    routes: ['/', '/users', '/settings'],
    actions: ['view', 'create', 'update', 'delete'],
    instanceScoped: [],
  },
  inventory: {
    key: 'inventory',
    label: 'Products',
    icon: 'package',
    models: ['Product'],
    routes: ['/products', '/products/new', '/products/:id', '/products/:id/edit'],
    actions: ['view', 'create', 'update', 'delete', 'export'],
    instanceScoped: [],
  },
  warehouse: {
    key: 'warehouse',
    label: 'Warehouse',
    icon: 'warehouse',
    models: ['Warehouse'],
    routes: ['/warehouse'],
    actions: ['view', 'create', 'update', 'delete'],
    instanceScoped: [],
  },
};
export default seedModules;

// Shared across hook instances: once the live registry arrives, later mounts
// (and a second consumer on the same page) start from the fresh copy.
let cache = seedModules;

/** Live module registry — seeded from the build-time copy, reconciled from the API. */
export function useModules() {
  const [modules, setModules] = useState(cache);
  useEffect(() => {
    let active = true;
    axios
      .get('/api/meta/modules', { withCredentials: true })
      .then((res) => {
        if (active && res.data && typeof res.data === 'object') {
          cache = res.data;
          setModules(res.data);
        }
      })
      .catch(() => {
        /* offline / not yet reachable — keep the seeded copy */
      });
    return () => {
      active = false;
    };
  }, []);
  return modules;
}
